import { Component, OnInit, Input } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { Translate } from 'src/app/pipe/translate.pipe';
import { LangEnum } from 'src/app/models/LangEnum';
declare const $: any;
@Component({
  selector: 'navigation',
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.css']
})
export class NavigationComponent implements OnInit {
  @Input() pageScrolled: boolean;
  languages: string[];
  constructor(private router: Router, private translate: Translate) {
    // this.router.onSameUrlNavigation = 'reload';
  }
  openMenu = false;
  ngOnInit(): void {
    this.languages = [];
    for (let l of Object.keys(LangEnum)) {
      this.languages.push(LangEnum[l]);
    }
  }
  tokenCheck() {
    return localStorage.getItem('token');
  }
  logout() {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    this.router.navigate(['./']);
  }
  changeLang(lang) {
    this.translate.setLocale(lang);
    location.reload();
  }
  getLang() {
    return this.translate.getLocale();
  }
  getFlag(lang?: string) {
    if (!lang) lang = this.getLang();
    return "./assets/img/" + lang + "_flag.svg"
  }
  scroll(id: string) {
    this.router.navigate(['./homepage', id]);
    // let el = document.getElementById(id);
    // el.scrollIntoView({ behavior: 'smooth', block: 'start' });

    // this.router.events.subscribe((evt) => {
    //   if (!(evt instanceof NavigationEnd)) {
    //       return;
    //   }
    //   window.scrollTo(0, 0)
    // });
  }
  showModalChangeLang() {
    $('.modal-lang').modal('show');
  }
}
